import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import React, { memo, useRef, useState } from 'react';
import useDashboardQueryFetch from '../../../../../hooks/useDashboardQueryFetch';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import SelectLocationModal from '../../../../modals/home-table-view/SelectLocationModal';
import useStyles from "../styles";

const LocationCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const { query: location, queryLoaded: locationLoaded } = useDashboardQueryFetch<string>(dashboard.id, 'Location');

    const [fieldHover, setFieldHover] = useState<boolean>(false);
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const locationRef = useRef<HTMLElement>(null);

    return (<>
        <Stack width="100%" ref={locationRef} onMouseLeave={() => setFieldHover(false)}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                onMouseEnter={() => setFieldHover(true)}>
                {locationLoaded ? (<>
                    <Stack direction="row" spacing={1} alignItems="stretch" justifyContent="flex-start">
                        {(!location || location === 'N/A') ? (
                            <Typography className={classes.plainText} fontWeight={500} color={`${theme.colors.neutral['500']} !important` }>
                                {'No location'}
                            </Typography>
                        ) : (
                            <Typography className={classes.plainText}>{location}</Typography>
                        )}
                    </Stack>
                    {fieldHover && (
                        <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                            <IconButton disableRipple
                                onClick={() => setEditModalOpen(true)}
                                sx={{ padding: 'unset !important'}}>
                                <EditOutlinedIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                            </IconButton>
                        </Stack>
                    )}
                </>) : (
                    <Box sx={{ width: '100%' }}>
                        <Skeleton animation="wave" className={classes.wave} />
                    </Box>
                )}
            </Stack>
        </Stack>
        {editModalOpen && (
            <SelectLocationModal
                open={editModalOpen}
                location={location || ''}
                dashboard={dashboard}
                anchorElement={locationRef.current}
                onClose={() => setEditModalOpen(false) } />
        )}
    </>);
}

export default memo(LocationCell);
